import { useEffect } from "react";

const MENU_PDF = "https://customer-assets.emergentagent.com/job_b37c987e-a9dd-4e8c-a72c-31526fea54f1/artifacts/eny0mhsm_TAKUMI-RAMEN-%E7%91%9E%E5%A3%AB-menu-A4-16p-%E4%BA%AE%E8%86%9C-02.222-Copy.pdf";

export default function MenuRedirect() {
  useEffect(() => {
    window.location.replace(MENU_PDF);
  }, []);

  return (
    <div data-testid="menu-redirect" className="min-h-screen flex items-center justify-center pt-20">
      <div className="text-center">
        <p className="font-display text-3xl text-primary mb-3">Ouverture du menu…</p>
        <p className="text-muted-foreground">
          Si rien ne se passe,{" "}
          <a href={MENU_PDF} target="_blank" rel="noopener noreferrer" className="underline text-primary" data-testid="menu-pdf-link">
            cliquez ici
          </a>
          .
        </p>
      </div>
    </div>
  );
}
